<template>
	<v-app>
		<v-main>
			<PageLoader v-if="loading"/>
			<template v-else>
				<navbar :class="$i18n.locale === 'ar' ? 'arabic' : 'english'"/>
				<v-container fluid class="pt-0">
					<router-view :class="$i18n.locale === 'ar' ? 'arabic' : 'english'"/>
				</v-container>
				<m-footer :class="$i18n.locale === 'ar' ? 'arabic' : 'english' "/>
			</template>
		</v-main>
	</v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import MFooter from '@/components/Footer.vue'
import PageLoader from '@/components/PageLoader.vue'
import { changeLang } from './i18n/i18n'
import axios from '@/axios'
import { mapState } from 'vuex'

export default {
	data () {
		return {
			loading: false
		}
	},

	components: {
		PageLoader,
		Navbar,
		MFooter
	},

	computed: {
		...mapState({
			branches: (state) => state.contactus.branches
		})
	},

	watch: {
		'$i18n.locale' (newLocale) {
			changeLang(newLocale)
			axios.defaults.headers.common['accept-language'] = newLocale;
			this.$vuetify.rtl = newLocale === 'ar';
			this.fetchData()
		}
	},

	methods: {
		fetchData () {
			this.loading = true
			Promise.all([
				this.$store.dispatch('categories/fetchAll'),
				this.$store.dispatch('categories/fetchTree'),
				this.$store.dispatch('products/fetchAll'),
				this.$store.dispatch('contactus/fetchAll'),
			]).finally(() => { this.loading = false })
		}
	},

	created () {
		this.fetchData()
	}
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');

#app {
	.arabic {
		&, * {
			font-family: "Cairo", sans-serif !important;
		}
	}
	.english {
		&, * {
			font-family: "Urbanist", sans-serif !important;
		}
	}

	.v-treeview-node__root {
		&:hover {
			cursor: pointer;
		}
		.v-treeview-node__level:first-child {
			width: 10px;
		}
	}
}
</style>
